<div class="draggable-container" #container>
    <!--
        Drag shield: covers the entire viewport while dragging to prevent iframes
        (e.g. PDF viewer, AI dashboard) from capturing pointer events.
        Iframes have their own browsing context so pointer-capture does not cross
        the document boundary — this transparent overlay intercepts those events
        at the parent document level, keeping CDK drag tracking smooth.
    -->
    @if (isDragging) {
        <div class="drag-shield"></div>
    }
    <div #draggableButton cdkDrag [cdkDragBoundary]="container" class="draggable-button"
        [class.transition-enabled]="!isDragging" [cdkDragFreeDragPosition]="dragPosition"
        (cdkDragStarted)="onDragStarted($event)" (cdkDragEnded)="onDragReleased($event)"
        (cdkDragReleased)="onDragReleased($event)">
        <ng-container *ngTemplateOutlet="floatingUI; context: { $implicit: data }"></ng-container>
    </div>
</div>